/**
 * `/settings` on its own.
 *
 * There is no single "first" settings screen, because which sections exist depends on
 * what the reader holds: an Organization Administrator lands on the firm profile, a
 * Partner who can read the directory but not the firm's record lands on Users. So this
 * sends them to the first section they can actually open rather than to a fixed one
 * that would answer 403 for half the firm.
 *
 * `replace` so that going Back from a settings screen leaves settings rather than
 * bouncing through the redirect again.
 */

import { EmptyState } from '@legalcrm/ui';
import { Navigate } from 'react-router-dom';

import { useVisibleSettingsSections } from './SettingsLayout';

export function SettingsIndexPage() {
  const sections = useVisibleSettingsSections();

  if (sections.length === 0) {
    // Reached only if the navigation item was shown on a capability none of these
    // screens uses. Says what is true — there is nothing here — and does not
    // speculate about permissions.
    return (
      <EmptyState
        title="Nothing to configure"
        description="There are no settings sections available on this account."
      />
    );
  }

  return <Navigate to={sections[0]!.to} replace />;
}
